import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: verify vs enrich. Started from the lesson page in a new tab;
 * never auto-started. It only points at the footage controls in the upload
 * modal (shown to officers with a footage seat) and never uploads anything.
 */
const tour: TutorialDefinition = {
  id: "verify-vs-enrich",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Verify vs enrich",
  description: "Choose whether footage checks your draft or writes into it.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "verify-vs-enrich",
  autoStart: false,
  steps: [
    {
      target: sel("newCaseDropdown"),
      waitFor: sel("newCaseDropdown"),
      title: "New Case",
      content: "Click New Case, choose Upload Files, and add an MP4 body-cam video.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("newCaseUpload"), event: "click" },
      hint: "Choose Upload Files to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadVideoAnalysis"),
      waitFor: sel("uploadVideoAnalysis"),
      waitTimeoutMs: 60000,
      title: "Analyze the footage",
      content:
        "This appears on a video row when your department has given you a footage seat. Turn it on to have the AI watch the video, not only hear it.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("uploadVideoVerify"),
      waitFor: sel("uploadVideoVerify"),
      waitTimeoutMs: 60000,
      title: "Verify",
      content:
        "Check the draft against the footage. Your narrative is written from the audio as usual, and differences from the video arrive as suggestions that start with Footage check.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("uploadVideoEnrich"),
      title: "Enrich",
      content:
        "Write footage observations into the draft. The narrative waits for the footage to be read, then includes what the camera shows. Choose this when there is little or no narration.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
